import React, { useState, useEffect } from 'react';
import WidgetWrapper from './WidgetWrapper';
import { entries } from '../../services/api';

const EntriesWidget = ({ darkMode = false, onError }) => {
  const [windowWidth, setWindowWidth] = useState(() => typeof window !== 'undefined' ? window.innerWidth : 1200);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const isMobile = windowWidth < 800;
  
  const [recentEntries, setRecentEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const entriesRes = await entries.list({ limit: 5 });
        setRecentEntries(entriesRes.data?.entries || entriesRes.entries || []);
      } catch (error) {
        console.error('EntriesWidget error:', error);
        onError?.('EntriesWidget', error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [onError]);

  const subTextColor = darkMode ? '#9ca3af' : '#6b7280';
  const textColor = darkMode ? '#f3f4f6' : '#111827';
  const borderColor = darkMode ? '#374151' : '#e5e7eb';

  return (
    <WidgetWrapper title="Recent Time Entries" loading={loading} darkMode={darkMode}>
      {recentEntries.length === 0 ? (
        <p style={{ color: subTextColor, textAlign: 'center', padding: 20 }}>No recent entries</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: `2px solid ${borderColor}` }}>
              <th style={{ textAlign: 'left', padding: isMobile ? 4 : 8, color: subTextColor, fontSize: isMobile ? 10 : 12 }}>Date</th>
              <th style={{ textAlign: 'left', padding: isMobile ? 4 : 8, color: subTextColor, fontSize: isMobile ? 10 : 12 }}>Customer</th>
              <th style={{ textAlign: 'right', padding: isMobile ? 4 : 8, color: subTextColor, fontSize: isMobile ? 10 : 12 }}>Hours</th>
              <th style={{ textAlign: 'right', padding: isMobile ? 4 : 8, color: subTextColor, fontSize: isMobile ? 10 : 12 }}>Cost</th>
            </tr>
          </thead>
          <tbody>
            {recentEntries.map(entry => (
              <tr key={entry.id} style={{ borderBottom: `1px solid ${borderColor}` }}>
                <td style={{ padding: isMobile ? 4 : 8, fontSize: isMobile ? 10 : 12, color: textColor }}>{entry.date}</td>
                <td style={{ padding: isMobile ? 4 : 8, fontSize: isMobile ? 10 : 12, color: textColor }}>{entry.customerName || 'N/A'}</td>
                <td style={{ textAlign: 'right', padding: isMobile ? 4 : 8, fontSize: isMobile ? 10 : 12, color: textColor }}>
                  {entry.hours + ((entry.minutes || 0) / 60)}
                </td>
                <td style={{ textAlign: 'right', padding: isMobile ? 4 : 8, fontSize: isMobile ? 10 : 12, color: textColor }}>
                  {entry.totalCost ? `$${entry.totalCost.toFixed(2)}` : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </WidgetWrapper>
  );
};

// Widget metadata
EntriesWidget.widgetId = 'recent-entries';
EntriesWidget.title = 'Recent Time Entries';
EntriesWidget.defaultSize = { cols: 6 };
EntriesWidget.category = 'business';

export default EntriesWidget;